<template>
  <q-page>
    <DeviatingVehicleCompositionTable />
  </q-page>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import DeviatingVehicleCompositionTable from '@/components/tools/deviating-vehicle-composition/DeviatingVehicleCompositionTable.vue'

export default defineComponent({
  name: 'DeviatingVehicleComposition',

  components: {
    DeviatingVehicleCompositionTable,
  },

  setup() {
    return {}
  },
})
</script>
